import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { useMediaPreviewContext } from "./MediaPreviewContext";

export const MediaPreviewLoader = () => {
    const { state } = useMediaPreviewContext();

    if (state.status !== "loading") {
        return null;
    }

    return (
        <PixelPlaceholderLoader
            height="100%"
            width="100%"
        />
    );
};
